'use es6';

import { combineReducers } from 'redux';
import { isBoolean, isObject } from 'underscore';
import SeamlessImmutable from 'seamless-immutable';
import { LAYOUT_EDITOR_OPTIONS_FETCH, LAYOUT_EDITOR_OPTIONS_TOGGLE_WIDGET_SIDEBAR, LAYOUT_EDITOR_OPTIONS_SAVE_ACCORDION_STATE } from 'DesignData/actions/ActionTypes';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { isExpired, createUpdatedTimestampForMissing } from 'DesignData/lib/localStorage';
import { getTimestampForAction } from 'DesignData/lib/actions';
/*
 * isWidgetSidebarOpen
 */

function isWidgetSidebarOpen(state = true, action) {
  switch (action.type) {
    case LAYOUT_EDITOR_OPTIONS_FETCH:
      {
        const {
          layoutEditorOptions
        } = action;
        if (!layoutEditorOptions) return state;

        if (isBoolean(layoutEditorOptions.isWidgetSidebarOpen)) {
          return layoutEditorOptions.isWidgetSidebarOpen;
        }

        return state;
      }

    case LAYOUT_EDITOR_OPTIONS_TOGGLE_WIDGET_SIDEBAR:
      {
        return !state;
      }

    default:
      {
        return state;
      }
  }
}
/*
 * accordionStates
 */


function accordionStatesById(state = EMPTY_OBJECT, action) {
  switch (action.type) {
    case LAYOUT_EDITOR_OPTIONS_FETCH:
      {
        const {
          layoutEditorOptions
        } = action;

        if (!(layoutEditorOptions && isObject(layoutEditorOptions.accordionStatesById))) {
          return state;
        }

        const newState = {};
        Object.keys(layoutEditorOptions.accordionStatesById).forEach(layoutId => {
          const data = layoutEditorOptions.accordionStatesById[layoutId];
          if (!data) return;

          if (data.updated) {
            if (!isExpired(data)) {
              newState[layoutId] = data;
            }
          } else {
            // The updated field was added later. Add for old data.
            newState[layoutId] = Object.assign({}, data, {
              updated: createUpdatedTimestampForMissing()
            });
          }
        });
        return SeamlessImmutable(newState);
      }

    case LAYOUT_EDITOR_OPTIONS_SAVE_ACCORDION_STATE:
      {
        const {
          layoutId,
          moduleId = 'default',
          key,
          isOpen
        } = action;

        if (!(layoutId && moduleId && key)) {
          return state;
        }

        const updated = getTimestampForAction(action);
        state = SeamlessImmutable.setIn(state, [layoutId, moduleId, key], isOpen);
        state = SeamlessImmutable.setIn(state, [layoutId, 'updated'], updated);
        return state;
      }

    default:
      {
        return state;
      }
  }
}
/*
 * Export
 */


export default combineReducers({
  isWidgetSidebarOpen,
  accordionStatesById
});